export default function LumoraWordmark() {
  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-0 z-40 flex justify-center">
      <h1 className="font-display text-white text-center leading-[0.85] select-none">
        <span className="block text-[24vw] md:text-[18vw] tracking-[0.08em]">
          LUMORA
        </span>
      </h1>
    </div>
  );
}